module.exports = {"TXTACL_Decrease":{"id":"TXTACL_Decrease","defaultMessage":"Decrease"},"TXTACL_Increase":{"id":"TXTACL_Increase","defaultMessage":"Increase"}}